module.exports = __webpack_public_path__ + "static/media/podcastText.d5c1831d.svg";